<script setup lang="ts">
import { computed, withDefaults } from 'vue'
import SectionedProgressBar from './SectionedProgressBar.vue'

interface PropTypes {
  colors?: Array<string>
  sectionCounts: Array<number>
  bgColor?: string
}

const props = withDefaults(defineProps<PropTypes>(), {
  colors: () => ['green-400'],
  sectionCounts: () => [1],
  bgColor: undefined
})

// Progess bar width in percentage
const getGrowBasis = (index: number): number => {
  const total = getTotal()
  if (total === 0) return 1
  const indexVal = props.sectionCounts[index - 1] || 0
  if (indexVal === 0) return 0
  const percentage = indexVal / total
  const basis = Math.round(percentage * 10)
  return basis
}

const getTotal = (): number => {
  return props.sectionCounts.reduce((sum, currVal) => sum + currVal, 0)
}

const totalSections = computed<number>(() => props.sectionCounts.length)
</script>

<template>
  <SectionedProgressBar
    :colors="props.colors"
    :bg-color="props.bgColor"
    :section-count="totalSections"
    :progress="totalSections"
    :grow-basis="getGrowBasis"
    :total="getTotal()"
  />
</template>
